// src/services/creditService.ts
import { apiClient } from './api';
import { OrganizationPlan, CreditUsage, PlanType } from '@/models/Credits';

export async function fetchOrganizationPlan(): Promise<OrganizationPlan> {
    const response = await apiClient.get<OrganizationPlan>('/credits/plan');
    return response.data;
}

export async function fetchCreditUsage(startDate?: string, endDate?: string,
    usageType?: string, limit: number = 100): Promise<CreditUsage[]> {
    const params = {
        start_date: startDate,
        end_date: endDate,
        usage_type: usageType,
        limit
    };
    const response = await apiClient.get<CreditUsage[]>('/credits/usage', { params });
    return response.data;
}

export async function fetchPlanTypes(): Promise<{ plans: PlanType[] }> {
    const response = await apiClient.get<{ plans: PlanType[] }>('/credits/plan-types');
    return response.data;
}